<ps-ui-modal class="quota-modal">
  <h2 psUiModalTitle class="text-center mx-5">
    Quotas for {{ data.qualification?.qualification_name }}:
  </h2>
  <ps-ui-modal-body class="quota-modal-body">
    <div
      class="row"
      *ngIf="
        data.qualification.is_range &&
        (!validValue(data.qualification.data[0].minValue) ||
          !validValue(data.qualification.data[0].maxValue))
      "
    >
      <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="alert alert-warning" role="alert">
          Please specify min and max
          {{ data.qualification?.qualification_name?.toLocaleLowerCase() }}
          before setting quotas.
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-8 flexdata_right">
        <label>FLEXIBLE</label>
      </div>
    </div>
    <div class="form-group justify-content-center mb-4">
      <div class="row form-distribution">
        <div class="col-4 col-lg-4 col-xl-6 px-2">
          <button
            type="button"
            class="btn btn-primary rounded-0"
            (click)="clearDistribution()"
          >
            Clear Distribution
          </button>
          <button
            id="distribute-quota-equally"
            type="button"
            class="btn btn-primary rounded-0"
            (click)="distributeEquallyPercentage()"
            [disabled]="!allowDistribution"
          >
            Distribute Equally
          </button>
          <button
            *ngIf="!grouping && showGroupingButton"
            type="button"
            class="btn btn-primary rounded-0"
            (click)="onGroupConditions()"
          >
            Group Conditions
          </button>
        </div>
        <div class="col-4 col-sm-2 col-md-2 col-lg-2 col-xl-1 px-2">
          <ps-ui-slider
            id="Flexible"
            (selectedChange)="flexibleFlagChange($event)"
            [selected]="data.flexible.enable"
          >
          </ps-ui-slider>
        </div>
        <div class="col-auto d-flex align-items-center px-0">
          <label for="Flexible" class="px-1">by</label>
          <input
            type="text"
            class="form-control border-0 border-bottom text-center rounded-0 max-width-60"
            [maxlength]="3"
            [(ngModel)]="data.flexible.value"
            (keyup)="flexibleValueChange()"
            psUiInputRestriction="[0-9]"
            data-e2e="quota-flexible"
          />
        </div>
        <div class="col-sm-1">
          <label for="percent">%</label>
        </div>
      </div>
    </div>

    <div>
      <div>
        <ps-ui-group-quota
          *ngIf="grouping"
          [quotas]="data.quotas"
          [showGroupButton]="grouping"
          [qualificationCode]="qualificationCode"
          [isCensusApplied]="isCensusApplied"
          [isSelectedForAida]="!!data.isSelectedForAida"
          (quotaChangedStatus)="toShowGroupingDetails($event)"
          (outputGroupedQuotas)="getGroupedQuotas($event)"
        >
        </ps-ui-group-quota>
      </div>
      <div *ngIf="!showGroupingDetails">
        <ps-ui-range-quota-row
          *ngIf="data.qualification.is_range && !isChildrenQualification"
          [data]="data"
          [flexible]="data.flexible"
          (quotasChanged)="updateQuotas($event)"
        ></ps-ui-range-quota-row>
        <ps-ui-multiselect-quota-row
          *ngIf="!data.qualification.is_range && !isChildrenQualification"
          [data]="data"
          [flexible]="data.flexible"
          (quotasChanged)="updateQuotas($event)"
        >
        </ps-ui-multiselect-quota-row>
        <ps-ui-child-age-gender-row
          *ngIf="isChildrenQualification"
          [data]="data"
          [flexible]="data.flexible"
          (quotasChanged)="updateQuotas($event)"
        >
        </ps-ui-child-age-gender-row>
      </div>
    </div>

    <div class="row justify-content-center mt-5">
      <div class="col-xs-12 col-sm-8 col-md-8 text-center">
        <p class="text-muted text-center mb-2">
          <strong>Total Remaining</strong>
        </p>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xs-12 col-sm-8 col-md-8 text-center">
        <p class="text-muted text-center mb-2">
          <b>{{ remaning }}</b>
        </p>
      </div>
    </div>
    <div class="row justify-content-center">
      <button
        id="apply-quota"
        [disabled]="remaning"
        type="button"
        class="btn btn-primary rounded-0"
        (click)="applyQuota('applyQuota')"
        psUiGtagEvent
        trackOn="click"
        action="quota_modal"
        category="Quotas"
        [params]="{ event_label: data.qualification?.qualification_name }"
      >
        Apply
      </button>
      <button
        *ngIf="!!data.isMcSurvey"
        [disabled]="remaning"
        type="button"
        class="btn btn-primary rounded-0"
        (click)="applyQuota('applyQuota', true)"
        psUiGtagEvent
        trackOn="click"
        action="quota_modal"
        category="Quotas"
        [params]="{ event_label: data.qualification?.qualification_name }"
      >
        Apply to all Locales
      </button>
      <button
        *ngIf="
          !data.isAdvancedTargeting &&
          data.qualification.qualification_code !== QUALIFICATION_CODES.ZIPCODE
        "
        [disabled]="remaning || (data.hasNestedGroup && data.isLiveSurveyEdit)"
        type="button"
        class="btn btn-primary rounded-0"
        (click)="applyQuota('applyNestQuota')"
        psUiGtagEvent
        trackOn="click"
        action="quota_modal"
        category="Quotas"
        [params]="{ event_label: data.qualification?.qualification_name }"
      >
        Apply & Nest
      </button>
      <button
        *ngIf="
          !!data.isMcSurvey &&
          !data.isAdvancedTargeting &&
          data.qualification.qualification_code !== QUALIFICATION_CODES.ZIPCODE
        "
        [disabled]="remaning || (data.hasNestedGroup && data.isLiveSurveyEdit)"
        type="button"
        class="btn btn-primary rounded-0"
        (click)="applyQuota('applyNestQuota', true)"
        psUiGtagEvent
        trackOn="click"
        action="quota_modal"
        category="Quotas"
        [params]="{ event_label: data.qualification?.qualification_name }"
      >
        Apply & Nest to all Locales
      </button>
    </div>
  </ps-ui-modal-body>
</ps-ui-modal>
